import { ArrowRightIcon } from 'lucide-react';

type Props = {
  children: string;
  disabled?: boolean;
  onClick?: () => void;
};

const SearchMoreButton = ({ children, disabled, onClick }: Props) => (
  <button
    type="button"
    disabled={disabled}
    onClick={onClick}
    className="flex h-[3.2rem] w-fit shrink-0 items-center gap-[0.4rem] pl-[1.2rem] pr-[0.8rem] rounded-[1rem] bg-white/8 headline5 text-primary cursor-pointer transition-colors hover:bg-white/16 disabled:cursor-not-allowed disabled:opacity-60 disabled:hover:bg-white/8">
    {children}
    <ArrowRightIcon className="size-[1.6rem]" />
  </button>
);

export { SearchMoreButton };
